<template>
  <form class="flex flex-col">
    <JoszakiInput
      v-model="v$.email.$model"
      class="mb-2"
      :validation-state="v$.email"
      :label="$t('customerRegistration.form.emailLabel')"
    ></JoszakiInput>
    <JoszakiInput
      v-model="v$.password.$model"
      class="mb-2"
      :label="$t('customerRegistration.form.passwordLabel')"
      :validation-state="v$.password"
      type="password"
    ></JoszakiInput>
    <JoszakiInput
      v-model="v$.confirmPassword.$model"
      class="mb-2"
      :validation-state="v$.confirmPassword"
      :label="$t('customerRegistration.form.confirmPasswordLabel')"
      type="password"
    ></JoszakiInput>
    <JoszakiCheckbox
      v-model="v$.termsAndConditionsAccepted.$model"
      :validation-state="v$.termsAndConditionsAccepted"
      class="mb-4"
    >
      <template #label>
        <i18n path="customerRegistration.form.acceptTermsAndConditions.text">
          <template #url>
            <NuxtLink
              :to="localePath({ name: 'documentsIndexPage' })"
              target="_blank"
              >{{
                $t("customerRegistration.form.acceptTermsAndConditions.link")
              }}</NuxtLink
            >
          </template>
        </i18n>
      </template>
    </JoszakiCheckbox>
    <div v-if="requestError" class="mb-4">
      <transition name="bounce" mode="in-out">
        <JoszakiPill type="warning" class="text-xs">{{
          requestError
        }}</JoszakiPill>
      </transition>
    </div>
    <JoszakiButton
      :is-submit="true"
      :expanded="true"
      size="lg"
      class="mb-4 mt-auto"
      :loading="submitting"
      @click="submit"
    >
      {{ $t("customerRegistration.form.submitButton") }}
    </JoszakiButton>
    <GoogleLoginButton
      request-phone
      :navigate-on-success="navigateOnSuccess"
      @success="$emit('success')"
    />
    <div v-if="hasLoginLink" class="text-center">
      {{ $t("customerRegistration.form.doYouHaveAnAccount") }}
      <NuxtLink
        :to="
          localePath({
            name: 'login',
            query: $route.query,
          })
        "
      >
        {{ $t("customerRegistration.form.linkToLogin") }}
      </NuxtLink>
    </div>
  </form>
</template>

<script>
import { useContext } from "@nuxtjs/composition-api";
import { useNavigateToCallbackIfAny } from "./useNavigateToCallbackIfAny.js";
import GoogleLoginButton from "~/components/_refactored/login/GoogleLoginButton.vue";
import { useCustomerRegistrationForm } from "~/components/_refactored/customer-registration/useCustomerRegistrationForm";

export default {
  name: "CustomerRegistrationForm",
  components: { GoogleLoginButton },
  props: {
    hasLoginLink: {
      type: Boolean,
      default: true,
    },
    /**
     * When false, the user stays on the current page after registration and a
     * `success` event is emitted instead of navigating. Used for dialog signup.
     */
    navigateOnSuccess: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { submitRegistrationForm, ...form } = useCustomerRegistrationForm();
    const navigateToCallbackIfAny = useNavigateToCallbackIfAny();
    const { localePath } = useContext();

    function loadNextPage() {
      navigateToCallbackIfAny(localePath({ name: "requestForTender" }));
    }

    async function submit() {
      if (await submitRegistrationForm()) {
        if (props.navigateOnSuccess) {
          loadNextPage();
        } else {
          emit("success");
        }
      }
    }

    return {
      ...form,
      submit,
    };
  },
};
</script>
